var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{staticClass:"region-picker",attrs:{"options":_vm.options},on:{"change":_vm.handleChange},model:{value:(_vm.iValue),callback:function ($$v) {_vm.iValue=$$v},expression:"iValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }